module.exports = __webpack_public_path__ + "static/media/Liberalize.0f7069e5.png";